const messages = {
    home: {
      title: 'Book Store',
      hint: 'Computer Science And Software Engineering',
      guessYouLike: 'Guess You Like',
    }
  }
   
  export default messages